// @flow

import React from "react";
import cx from "classnames";
import SVG from "react-inlinesvg";

import { ratioToPercentage } from "../../utils/unitConversions";

import styles from "./ProgressBar.scss";
import checkmark from "../../assets/icons/other/checkmark.svg";

type StepPanelProps = {
  isActive: boolean,
  isCompleted: boolean,
  outOf: number,
  stepCount: number,
  title: string,
  valid: number
};

const StepPanel = ({ isActive, isCompleted, outOf, stepCount, title, valid }: StepPanelProps) => (
  <div
    className={cx(styles.panelWrapper, {
      [styles.twoStep]: stepCount === 2,
      [styles.threeStep]: stepCount === 3,
      [styles.fourStep]: stepCount === 4
    })}
  >
    <div
      className={cx(styles.panel, {
        [styles.inactive]: !isActive,
        [styles.disabled]: !isActive && !isCompleted
      })}
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.numericIndicator}>
        {isCompleted ? <SVG src={checkmark} alt="" /> : `${valid}/${outOf}`}
      </div>
      {(isActive || isCompleted) && (
        <div
          className={cx(styles.bar, styles.stepBar, { [styles.greyedOut]: isCompleted })}
          style={{ width: isCompleted ? "100%" : ratioToPercentage(valid, outOf) }}
        />
      )}
    </div>
  </div>
);

export default StepPanel;
